'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var PromiseWorker = require('promise-worker');
var rxjs_1 = require('rxjs');
var WorkerMessenger = (function () {
  function WorkerMessenger(inputWorker, cb) {
    this.inputWorker = inputWorker;
    this.cb = cb;
    this.live = false;
    this.init(inputWorker);
  }
  WorkerMessenger.prototype.init = function (worker) {
    if (this.live === false) {
      this.worker = worker;
      this.worker.onerror = this.onError;
      this.promiseWorker = new PromiseWorker(this.worker);
      this.live = true;
    } else {
    }
  };
  WorkerMessenger.prototype.postMessage = function (input) {
    var _this = this;
    return rxjs_1.Observable.create((observer) => {
      _this.promiseWorker
        .postMessage(input)
        .then((response) => {
          observer.next(response);
          if (_this.cb) {
            _this.cb(response);
          }
        })
        .catch((error) => {
          observer.error(error);
          if (_this.cb) {
            _this.cb(error);
          }
        });
    });
  };
  WorkerMessenger.prototype.postMessagePromise = function (input) {
    var _this = this;
    return new Promise((resolve, reject) => {
      _this.promiseWorker
        .postMessage(input)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  WorkerMessenger.prototype.terminate = function () {
    if (this.live === true) {
      this.worker.terminate();
      this.live = false;
    } else {
      console.warn('Cannot terminate: Worker is already down.');
    }
  };
  WorkerMessenger.prototype.onError = function (err) {
    console.error('Something went wrong registering the worker: ' + err);
  };
  return WorkerMessenger;
})();
exports.WorkerMessenger = WorkerMessenger;
//# sourceMappingURL=WorkerMessenger.js.map
